import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import './index.css';
import App from './App';

// Amplify v6 config — must use Auth.Cognito.loginWith.oauth format.
// The v5-style flat config with aws-exports.js silently fails for OAuth (no redirect, no error).
const isNative = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
const webOrigin = typeof window !== 'undefined' ? window.location.origin : '';

const redirectSignIn = isNative
  ? ['uk.co.wolftechnologies.recall://callback']
  : [`${webOrigin}/auth/callback`];

const redirectSignOut = isNative
  ? ['uk.co.wolftechnologies.recall://callback']
  : [`${webOrigin}/login`];

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-2_0jtrUQ84g',
      userPoolClientId: '5ve2ahpvh1enu6go0patr9s47j',
      identityPoolId: 'eu-west-2:98306b4e-16b1-4dfc-8d98-9aae04c90953',
      loginWith: {
        oauth: {
          domain: 'recall-flashcards.auth.eu-west-2.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
